var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLeftArrow({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14.384,
    height: 14.384,
    viewBox: "0 0 14.384 14.384",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_29872",
    "data-name": "Path 29872",
    d: "M0,0H8.671V8.671",
    transform: "translate(7.192 13.323) rotate(-135)",
    fill: "none",
    stroke: "#000c1f",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    opacity: 0.3
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeftArrow);
export default __webpack_public_path__ + "static/media/left-arrow.f016eb713ce63671f5bbda76e6012bd3.svg";
export { ForwardRef as ReactComponent };